module.exports = __webpack_public_path__ + "img/basico1.fw.58d60de5.png";